// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
    font-family: 'Roboto', sans-serif !important;
}

.input-w-default {
    width: 304px;
}

.invalid-feedback {
    font-size: 80% !important;
}


    /* Popovers */
.popover-body {
    text-align: center !important;
}

.popover-body * {
    text-align: left !important;
}

.popover {
    z-index: 1039 !important;
}

.b-popover-danger.bs-popover-top > .arrow::before, .b-popover-danger.bs-popover-auto[x-placement^='top'] > .arrow::before {
    border-top-color: transparent !important;
}

.b-popover-danger.bs-popover-bottom > .arrow::before, .b-popover-danger.bs-popover-auto[x-placement^='bottom'] > .arrow::before {
    border-bottom-color: transparent !important;
}

.b-popover-danger.bs-popover-bottom > .arrow::after, .b-popover-danger.bs-popover-auto[x-placement^='bottom'] > .arrow::after {
    border-bottom-color: #f8d7da !important;
}

.b-popover-danger {
    border: transparent !important;
}`, "",{"version":3,"sources":["webpack://./assets/stylesheets/global.css"],"names":[],"mappings":"AAAA;IACI,4CAA4C;AAChD;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,yBAAyB;AAC7B;;;IAGI,aAAa;AACjB;IACI,6BAA6B;AACjC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,8BAA8B;AAClC","sourcesContent":["body {\n    font-family: 'Roboto', sans-serif !important;\n}\n\n.input-w-default {\n    width: 304px;\n}\n\n.invalid-feedback {\n    font-size: 80% !important;\n}\n\n\n    /* Popovers */\n.popover-body {\n    text-align: center !important;\n}\n\n.popover-body * {\n    text-align: left !important;\n}\n\n.popover {\n    z-index: 1039 !important;\n}\n\n.b-popover-danger.bs-popover-top > .arrow::before, .b-popover-danger.bs-popover-auto[x-placement^='top'] > .arrow::before {\n    border-top-color: transparent !important;\n}\n\n.b-popover-danger.bs-popover-bottom > .arrow::before, .b-popover-danger.bs-popover-auto[x-placement^='bottom'] > .arrow::before {\n    border-bottom-color: transparent !important;\n}\n\n.b-popover-danger.bs-popover-bottom > .arrow::after, .b-popover-danger.bs-popover-auto[x-placement^='bottom'] > .arrow::after {\n    border-bottom-color: #f8d7da !important;\n}\n\n.b-popover-danger {\n    border: transparent !important;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
